export default "__VITE_ASSET__DcxZ1l8B__"